import React, { useEffect, useState } from "react";
const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;
// This fixes the react-hooks/exhaustive-deps ESLint warning
const roles = [
  { role_id: "fe42ee60-9133-4f0e-b543-740d8697c23b", role: "User" },
  { role_id: "ac9be322-db89-4beb-854a-46f2c91de374", role: "Admin" },
];

const AdminConfig = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${apiBaseURL}/users/allUsers`);
        if (!response.ok) throw new Error("Failed to fetch users");

        const usersData = await response.json();
        console.log(usersData);

        const usersWithRoles = usersData.map((user) => {
          const role = roles.find((r) => r.role_id === user.user_role);
          return {
            ...user,
            role_name: role ? role.role : "Unknown Role",
          };
        });

        const sortedUsers = usersWithRoles.sort((a, b) =>
          `${a.first_name} ${a.last_name}`.localeCompare(
            `${b.first_name} ${b.last_name}`
          )
        );

        setUsers(sortedUsers);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  const handleRoleChange = async (userId, newRoleName) => {
    try {
      const response = await fetch(
        `${apiBaseURL}/users/${userId}/role?role_name=${newRoleName}`, // Use `role_name` in the API call
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Failed to update user role");

      const updatedUsers = users.map((user) =>
        user.userid === userId
          ? {
              ...user,
              user_role: roles.find((r) => r.role === newRoleName).role_id, // Update `user_role` with the `role_id`
              role_name: newRoleName, // Update `role_name`
            }
          : user
      );

      setUsers(updatedUsers);
      alert("User role updated successfully!");
    } catch (error) {
      console.error("Error updating user role:", error);
    }
  };

  return (
    <div className="container mx-auto font-gotham">
      <div className="overflow-x-auto bg-white rounded-lg shadow-lg border border-gray-200">
        <table className="table-auto w-full text-sm text-gray-700">
          <thead className="bg-teal-50 text-gray-800">
            <tr>
              <th className="px-6 py-3 text-left font-semibold">Name</th>
              <th className="px-6 py-3 text-left font-semibold">User ID</th>
              <th className="px-6 py-3 text-left font-semibold">Country</th>
              <th className="px-6 py-3 text-left font-semibold">Role</th>
              <th className="px-6 py-3 text-left font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.userid} className="hover:bg-gray-100">
                <td className="px-6 py-4">
                  {user.first_name} {user.last_name}
                </td>
                <td className="px-6 py-4">{user.userid}</td>
                <td className="px-6 py-4">{user.country}</td>
                <td className="px-6 py-4">{user.role_name}</td>
                <td className="px-6 py-4">
                  <select
                    value={user.role_name}
                    onChange={(e) => {
                      handleRoleChange(user.userid, e.target.value);
                    }}
                    className="bg-gray-50 border border-gray-300 rounded-md p-2 text-sm hover:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                  >
                    {roles.map((role) => (
                      <option key={role.role_id} value={role.role}>
                        {role.role}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminConfig;
